import { connect } from "react-redux";
import { Dispatch } from "redux";
import IAppState from "../../../redux/types/IAppState";
import { RouteChildrenProps } from 'react-router';
import {
    loginThunk
} from "../../../redux/thunks/AccountThunks";
import { MSALCallbackCatch } from "./MSALCallbackCatch";
import { ILoginViewModel } from "../../types/ILoginViewModel";

export default connect(
    (state: IAppState, props: RouteChildrenProps) => ({
        redirect: state.router?.location || undefined,
        isSignedIn: state.account.isSignedIn
    }),
    (dispatch: Dispatch) => ({
        login: (viewModel: ILoginViewModel, redirectInfo: any) => dispatch<any>(loginThunk(viewModel, redirectInfo)),
    })
)(MSALCallbackCatch);